import React from "react";

import { AlertTriangle } from "lucide-react";

import {
  formatRoleGapImpact,
  formatRoleGapVacantSince,
  roleGapKey,
} from "./teamViewsHelpers";
import Button from "../../../Components/Button";
import CommonModal from "../../../Components/Modal";
import type { RoleGapItem } from "../../../Store/Reducers/TeamViewsSlice";

type TeamViewsRoleGapsModalProps = {
  open: boolean;
  gaps: RoleGapItem[];
  onClose: () => void;
};

/** Full Role Gaps list — opened from the compact summary banner. */
const TeamViewsRoleGapsModal: React.FC<TeamViewsRoleGapsModalProps> = ({
  open,
  gaps,
  onClose,
}) => (
  <CommonModal
    isOpen={open}
    toggle={onClose}
    size="2xl"
    usePortal
    title="Role Gaps"
    contentClassName="overflow-y-auto"
    footer={
      <div className="flex justify-end">
        <Button variant="primary" onClick={onClose}>
          Close
        </Button>
      </div>
    }
  >
    <div className="rl-prototype-skin">
      <div className="tv-role-gaps-strip tv-role-gaps-strip--modal mb-0">
        <div className="tv-role-gaps-hdr">
          <AlertTriangle className="h-3.5 w-3.5 shrink-0" aria-hidden />
          ROLE GAPS ({gaps.length})
        </div>
        {gaps.map((gap: RoleGapItem) => {
          const roleLabel = gap.role_name || gap.role_key;
          return (
            <div className="tv-role-gap-item" key={roleGapKey(gap)}>
              <span aria-hidden>⚠</span>
              <span>
                <strong>{gap.account_name || "Account"}</strong>
                {" — "}
                {roleLabel} vacant since{" "}
                {formatRoleGapVacantSince(gap.vacant_since)}
                {" — "}
                {formatRoleGapImpact(gap)}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  </CommonModal>
);

export default TeamViewsRoleGapsModal;
